module.exports = __webpack_public_path__ + "img/head-banner.667c5ec4.jpg";